export const isDevelopment = true;
export const isProduction = false;
export const isTesting = false;
